import { Card, CardBody,Row, Col } from "reactstrap";
import { dynamicImage } from "../../../Service";
import { H6, Image } from "../../../AbstractElements";

const IncomeBoxes = (props: any) => {
  return (
    <>
    <Col sm="12" md="12" className="order-md-5 order-4">
     
     <Row>  <Col sm="6" xl="3" md="3">
        <Card className="boxshadow" style={{ background: "linear-gradient(135deg, #6a11cb, #2575fc)" }}>
          <CardBody className="px-2 py-3 course-table">
            <div className="income-box">
              <Image
                src={dynamicImage("Icons/3.png")}
                className="copy-icon"
                alt="Income Icon"
                style={{ background: "radial-gradient(#6a11cb, #2575fc)" }}
              />
              <div className="referblock">
                <div className="ValueData">
                  {props.incomeData?.TotalDirectCount}
                </div>
                <div className="divideBox">
                  <div>
                    <span className="Valuetext">Paid:</span>
                    <span className="SecData">
                      {props.incomeData?.PaidDirectCount}
                    </span>
                  </div>
                  |
                  <div>
                    <span className="Valuetext">UnPaid:</span>
                    <span className="SecData">
                      {props.incomeData?.UnPaidDirectCount}
                    </span>
                  </div>
                </div>
                <H6 className="mt-0">Direct Team</H6>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      <Col sm="6" xl="3" md="3">
        <Card className="boxshadow" style={{ background: "linear-gradient(135deg, #ff6a00, #ee0979)" }}>
          <CardBody className="px-2 py-3 course-table">
            <div className="income-box">
              <Image
                src={dynamicImage("Icons/2.png")}
                className="copy-icon"
                alt="Income Icon"
                style={{ background: "radial-gradient(#ff6a00, #ee0979)" }}
              />
              <div className="referblock">
                <div className="ValueData">{props.incomeData?.TotalTeam}</div>
                <div className="divideBox">
                  <div>
                    <span className="Valuetext">Paid:</span>
                    <span className="SecData">
                      {props.incomeData?.PaidTeam}
                    </span>
                  </div>
                  |
                  <div>
                    <span className="Valuetext">UnPaid:</span>
                    <span className="SecData">
                      {props.incomeData?.UnPaidTeam}
                    </span>
                  </div>
                </div>
                <H6 className="mt-0">Total Team</H6>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      <Col sm="6" xl="3" md="3">
        <Card className="boxshadow" style={{ background: "linear-gradient(135deg, rgb(39 170 176), #2196F3)" }}>
          <CardBody className="px-2 py-3 course-table">
            <div className="income-box">
              <Image
                src={dynamicImage("Icons/4.png")}
                className="copy-icon"
                alt="Income Icon"
                style={{ background: "radial-gradient(rgb(39 170 176), #2196F3)" }}
              />
              <div className="referblock">
                <div className="ValueDataUser">
                  <span className="Valuetext">User ID:</span>
                  <span className="SecData">{props.incomeData?.SUserId1}</span>
                </div>
                <div className="ValueDataUser">
                  <span className="Valuetext">Name:</span>
                  <span className="SecData">{props.incomeData?.SName1}</span>
                </div>

                <H6 className="mt-0">Sponsor Details</H6>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Latest boxes */}
      <Col sm="6" xl="3" md="3">
        <Card className="boxshadow" style={{ background: "linear-gradient(135deg, rgb(57 25 126), rgb(42 149 166)" }}>
          <CardBody className="px-2 py-3 course-table">
            <div className="income-box">
              <Image
                src={dynamicImage("Icons/1.png")}
                className="copy-icon"
                alt="Income Icon"
                style={{ background: "radial-gradient(rgb(57 25 126), rgb(42 149 166)" }}
              />
              <div className="referblock">
                <div className="ValueData">
                  ₹ {props.incomeData?.BalancePayout}
                </div>
                <div className="divideBox">
                  {/* <div>
                    <span className="Valuetext">Paid:</span>
                    <span className="SecData">{props.incomeData?.PaidDirectCount}</span>
                  </div>
                  |
                  <div>
                    <span className="Valuetext">UnPaid:</span>
                    <span className="SecData">{props.incomeData?.UnPaidDirectCount}</span>
                  </div> */}
                </div>
                <H6 className="mt-2">Balance Payout</H6>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      <Col sm="6" xl="3" md="3">
        <Card className="boxshadow" style={{ background: "linear-gradient(135deg, #11998e, #38ef7d)" }}>
          <CardBody className="px-2 py-3 course-table">
            <div className="income-box">
              <Image
                src={dynamicImage("Icons/dispatch2.png")}
                className="copy-icon"
                alt="Income Icon"
                style={{ background: "radial-gradient(#11998e, #38ef7d)" }}
              />
              <div className="referblock">
                <div className="ValueData">
                  ₹ {props.incomeData?.DispatchedPayout}
                </div>
                <div className="divideBox">
                  {/* <div>
                    <span className="Valuetext">Paid:</span>
                    <span className="SecData">{props.incomeData?.PaidDirectCount}</span>
                  </div>
                  |
                  <div>
                    <span className="Valuetext">UnPaid:</span>
                    <span className="SecData">{props.incomeData?.UnPaidDirectCount}</span>
                  </div> */}
                </div>
                <H6 className="mt-2">Dispatched Payout</H6>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col> </Row>
      </Col>
      {/* <Col sm="6" xl="3" md="3">
        <Card className="boxshadow">
          <CardBody className="p-2 course-table">
            <div className="income-box">
              <Image
                src={dynamicImage("Icons/1.png")}
                className="copy-icon"
                alt="Income Icon"
              />
              <div className="referblock">
                <span className="ValueData">₹{props.incomeData?.LevelIncome}</span>
                <H6 className="mt-0"> Level Income Report </H6>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col> */}

     
    </>
  );
};

export default IncomeBoxes;
